import { useQuery } from "@tanstack/react-query";
import api from "./__api__/ecrf-data-management";

export const useQueryEcrfDataManagements = (page?: string | string[] | undefined) => {
  return useQuery({
    queryKey: [api.getEcrfDataManagementsPath(page)],
    queryFn: api.getEcrfDataManagements(page),
  });
};

export default { useQueryEcrfDataManagements };